import { createFileRoute } from "@tanstack/react-router";
import { Alert } from "antd";
import { useEffect } from "react";
import { BasePageContainer } from "@/components/base";
import { useActions } from "@/contexts/actions-context";
import { usePageTitle } from "@/contexts/page-title-context";

export const Route = createFileRoute(
	"/_authenticated/$orgSlug/workspaces/$workspaceId/runbooks/",
)({
	component: Runbooks,
});

function Runbooks() {
	const { setTitle } = usePageTitle();
	const { setActions } = useActions();

	useEffect(() => {
		setTitle("Runbooks");
		setActions([]);
	}, [setTitle, setActions]);

	return (
		<BasePageContainer>
			<Alert
				type="info"
				title="Coming Soon"
				description="Runbooks are not yet available. Check back later."
			/>
		</BasePageContainer>
	);
}
